// Import the SCSS file for HMR to work
import '../scss/styles.scss';


//
import { mobileMenu } from './modules/mobileMenu.js'
import { sliders } from './modules/sliders.js'
import { navBackdrop } from './modules/navBackdrop.js'
import { megaMenuHeights } from './modules/megaMenuHeights.js'
import { accessibleNavigation } from './modules/accessibleNavigation.js'
import { videoPopup } from './modules/videoPopup.js'
import { dragScroll } from './modules/dragScroll.js'
import { pdpNav } from './modules/pdpNav.js'


// Global object to store functions which can be called anywhere
window.HappyHorizon = {}

const initializeModules = () => {
    mobileMenu.init()
    sliders.init()
    navBackdrop.init()
    megaMenuHeights.init()
    accessibleNavigation.init()
    videoPopup.init()
    dragScroll.init()
    pdpNav.init()
}

const afterLoad = () => {
    // Initialize modules
    initializeModules()

    // Expose modules globally
    window.HappyHorizon = {
        mobileMenu,
        sliders,
        navBackdrop,
        megaMenuHeights,
        accessibleNavigation,
        videoPopup,
        dragScroll,
        pdpNav,
        reinitialize: initializeModules // Expose a single reinitialization function
    }


}

document.addEventListener('DOMContentLoaded', afterLoad)
